module.exports = __webpack_public_path__ + "img/12_31.a19e3d50.png";